import { isDevelopment, isSSR } from "~/constants";

const logLevels = ["error", "warn", "debug"] as const;
export type LogLevel = (typeof logLevels)[number];

/**
 * Create logger instance
 * @param context - The calling file or function
 */
export const createLogger = (context: string) => {
  const logFactory =
    (level: LogLevel) =>
    (...args: any[]) => {
      // for now, just output if in develop
      if (isDevelopment) {
        // route all SSR logged to console.log, because nuxt doesn't pay attention to anything else
        console[isSSR ? "log" : level](`${context}:`, ...args);
      }
    };

  // turn array of logLevels into log functions
  const logger = logLevels.reduce(
    (acc, level) => ({
      ...acc,
      [level]: logFactory(level),
    }),
    {},
    // convince TS
  ) as Record<LogLevel, (...args: any[]) => void>;

  // utilities

  /**
   * Create a log a timer
   * @param name - The thing being timed
   * usage:
   * const stopTimer = logger.time('nameOfFunction');
   * before any return and end of function
   * stopTimer('Any additional info');
   */
  const time = (name: string) => {
    const start = Date.now();
    return (...args: any[]) => {
      if (args[0] === false) return;
      const ms = Date.now() - start;
      logger.debug(`[${ms}ms] ${name}${args.length ? "," : ""}`, ...args);
    };
  };

  return {
    ...logger,
    time,
  };
};
